import { render, staticRenderFns } from "./IncomeTypeForm.vue?vue&type=template&id=c983773a"
import script from "./IncomeTypeForm.vue?vue&type=script&lang=js"
export * from "./IncomeTypeForm.vue?vue&type=script&lang=js"
import style0 from "./IncomeTypeForm.vue?vue&type=style&index=0&id=c983773a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports